// extracted by css-extract-rspack-plugin
export default {"cls1":"ThreeImages-cls1_ylv","cls2":"ThreeImages-cls2_JHl ThreeImages-cls1_ylv"};